<template>
  <div class="poster">
    <ul class="normal-card flex-between">
      <li v-for="item in totalList" :key="item.title">
        <p>{{ item.title }}</p>
        <h3>{{ item.num || 0 }}</h3>
      </li>
    </ul>
    <div class="content normal-card" v-if="navList.length > 0">
      <h4>常用工具</h4>
      <div class="content-nav">
        <dl v-for="item in navList" :key="item.name" @click="goRouter(item)">
          <van-icon class="dl-icon" :class="[item.scale ? 'special' : '']" :style="{ background: item.bg }" :name="item.img" />
          <dd>{{ item.name }}</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getCustomerNum, getCustomerLimit } from "@/server/api.js";
import { addressBar, wefunstatistics } from "@/utils/public";
export default {
  data() {
    return {
      list: [],
      pageNum: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      total: 0, // 总条数
      numObj: {
        total: 0,
      },
      totalList: [
        { title: "客户总数", num: "-" },
        { title: "今日新增", num: "-" },
        { title: "今日流失", num: "-" },
      ],

      startDate: new Date().toLocaleDateString().replace(/\//g, "-"),
      endDate: new Date().toLocaleDateString().replace(/\//g, "-"),
      navLists: [
        {
          img: require("../../assets/images/total.png"),
          name: "客户统计",
          bg: "#d8d8d8 linear-gradient(180deg, #5bc6fc 0%, #3484e5 100%)",
          route: "customerTotal",
        },
        {
          img: require("../../assets/images/list.png"),
          name: "客户列表",
          bg: "#D8D8D8 linear-gradient(183deg, #FCC19F 0%, #F6615D 100%)",
          route: "list",
        },
        {
          img: require("../../assets/images/channel.png"),
          name: "渠道活码",
          bg: "#D8D8D8 linear-gradient(180deg, #DBAEFF 0%, #785EFC 100%)",
          route: "channel",
        },
        {
          img: require("../../assets/images/Employment.png"),
          bg: "#D8D8D8 linear-gradient(180deg, #FFB200 0%, #FF4964 100%)",
          name: "学员就业",
          link: "https://rtirrdkybb.feishu.cn/drive/folder/fldcnVQPLjLbV4qBE7xgD4uRf6b",
          scale: 2,
        },
        {
          img: require("../../assets/images/groupSend.png"),
          bg: "#D8D8D8 linear-gradient(180deg, #D989FF 0%, #C54AFF 100%)",
          name: "客户群发",
          route: "customerGroup",
          scale: 2,
        },
        {
          img: require("../../assets/images/poster.png"),
          bg: "#D8D8D8 linear-gradient(180deg, #FFC300 0%, #FF7000 100%)",
          name: "海报素材",
          route: "material",
          scale: 2,
        },
        {
          img: require("../../assets/images/fee.png"),
          bg: "#D8D8D8 linear-gradient(180deg, #8ADD00 0%, #3CA700 100%)",
          name: "学费查询",
          route: "tuition",
          scale: 2,
        },
        {
          img: require("../../assets/images/enterInfo.png"),
          bg: "#D8D8D8 linear-gradient(180deg, #26C3FF 0%, #26A9EE 100%)",
          name: "学员录入",
          route: "studentInfoEnter",
          scale: 2,
        },
        {
          img: require("../../assets/images/groupCode.png"),
          bg: "#D8D8D8 linear-gradient(180deg, #899EFF 0%, #564AFF 100%)",
          name: "群组活码",
          route: "groupCodeList",
          scale: 2,
        },
        {
          img: require("../../assets/images/openClass.png"),
          bg: "#D8D8D8 linear-gradient(180deg, #70E670 0%, #0AA027 100%)",
          name: "开班计划",
          route: "openClassList",
          scale: 2,
        },
      ],
      navList: [], //菜单权限列表
    };
  },
  watch: {
    // "$store.state.tokenFlag": function (newval) {
    //   if (newval) {
    //     this.hasInit();
    //   }
    // },
  },
  mounted() {
    let windowurl = window.location.href.split("#")[0] || "http://tm-qw.1000phone.net/index";
    if (localStorage.getItem("token")) {
      this.getCustomerNums();
      let userId = localStorage.getItem("userid");
      let superAdmin = Number(JSON.parse(localStorage.getItem("userInfo")).superAdmin);
      this.getCustomerLimit(userId, superAdmin);
      wefunstatistics("5", window.location.href.split("#")[0]);
    } else {
      addressBar("token", windowurl);
    }
  },
  methods: {
    //获取用户菜单权限
    async getCustomerLimit(userId, superAdmin) {
      let params = {
        userId: userId,
        superAdmin: superAdmin,
      };
      let res = await getCustomerLimit(params);

      if (res.code !== "200") return Toast.fail(res.msg);
      if (res.data.length > 0) {
        if (res.data.includes("customer:statistics:query")) {
          this.navList.push(this.navLists[0]);
        }
        if (res.data.includes("customer:query")) {
          this.navList.push(this.navLists[1]);
        }
        if (res.data.includes("qrcode:query")) {
          this.navList.push(this.navLists[2]);
          this.navList.push(this.navLists[3]);
        }
        if (res.data.includes("wegroupsend:save")) {
          this.navList.push(this.navLists[4]);
        }
        if (res.data.includes("qrcode:query")) {
          this.navList.push(this.navLists[5]);
        }
        if (res.data.includes("xfcx:query")) {
          this.navList.push(this.navLists[6]);
        }
        if (res.data.includes("student:qwAddForInfoFlow")) {
          this.navList.push(this.navLists[7]);
        }
        if (res.data.includes("wegrcode:query")) {
          this.navList.push(this.navLists[8]);
        }
        if (res.data.includes("class:query")) {
          this.navList.push(this.navLists[9]);
        }
      }
    },

    //跳转到指定页面
    async goRouter(item) {
      if (item.route) {
        await this.$router.push(item.route);
        // eslint-disable-next-line no-empty
      } else {
        if (item.name === "学员就业") {
          await wefunstatistics("6", item.link);
          window.location.href = item.link;
        }
      }
    },

    //获取客户总数
    async getCustomerNums() {
      let res = await getCustomerNum();
      if (res.code !== "200") return Toast.fail(res.msg);
      this.totalList[0].num = res.data.total;
      this.totalList[1].num = res.data.today;
      this.totalList[2].num = res.data.todayLoss;
    },
  },
};
</script>

<style lang="less" scoped>
.poster {
  width: 100%;
  ul {
    border-radius: 14px;
    height: 200px;
    padding: 0 55px;
    margin-bottom: 20px;
    p {
      font-size: 28px;
      padding-bottom: 18px;
    }
    h3 {
      font-size: 36px;
    }
  }
  .content {
    padding: 32px 34px 0px;
    h4 {
      font-size: 32px;
      margin-bottom: 27px;
    }
    .content-nav {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
    dl {
      width: 25%;
      text-align: center;
      .dl-icon {
        width: 98px;
        height: 98px;
        border-radius: 26px;
        img {
          width: 44px;
          height: 48px;
          margin-top: 25px;
          display: inline-block;
          // margin-bottom: 2px;
        }
      }
      .special {
        // overflow: hidden;
        img {
          transform: scale(2);
        }
      }
      dd {
        font-size: 24px;
        margin: 14px 0 36px;
      }
    }
  }
}
</style>
